import './App.scss';
import Router from './routers/CoreRouter';
import 'antd/dist/antd.css';

function App() {
    return (
        <div className="App">
            <Router />
        </div>
    );
}

export default App;
